// extracted by mini-css-extract-plugin
export default {"navbar":"Nav_navbar__hyXXt","links":"Nav_links__uQd2B"};